module.exports = __webpack_public_path__ + "img/wlc2.6ade4840.jpg";